import { AssetDto } from '@nusign/picflow-backend-types';
import { AssetGroup } from '../../types/asset-group.type';

export const getNewAsset = (
  assets: AssetDto[],
  groups: AssetGroup[],
  lastSelected: AssetDto,
  columnCount: number,
  key: string
): AssetDto => {
  const index = assets.findIndex(i => i.id === lastSelected.id);

  if (key === 'ArrowLeft') {
    if (index <= 0) return;
    return assets[index - 1];
  }

  if (key === 'ArrowRight' || key === 'Tab') {
    if (index >= assets.length - 1) return;
    return assets[index + 1];
  }

  const groupIndex = groups.findIndex(g => g.assets.find(i => i.id === lastSelected.id));
  let group = groups[groupIndex];
  const indexG = group.assets.findIndex(i => i.id === lastSelected.id);

  if (key === 'ArrowUp') {
    if (indexG < columnCount) {
      const nextGroup = groups[groupIndex - 1];
      if (!nextGroup) return;
      group = nextGroup;
      let newIndex = Math.floor((nextGroup.assets.length - 1) / columnCount) * columnCount;
      newIndex += indexG;
      if (group.assets.length - 1 < newIndex) newIndex = group.assets.length - 1;
      return group.assets[newIndex];
    }
    return group.assets[indexG - columnCount];
  }

  if (key === 'ArrowDown') {
    if (indexG >= group.assets.length - columnCount) {
      const nextGroup = groups[groupIndex + 1];
      if (!nextGroup) {
        if (indexG >= group.assets.length - 1) return;
        return group.assets[group.assets.length - 1];
      }
      let newIndex = indexG % columnCount;
      if (nextGroup.assets.length - 1 < indexG) newIndex = nextGroup.assets.length - 1;
      return nextGroup.assets[newIndex];
    }
    return group.assets[indexG + columnCount];
  }
};
